// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.user-call-notification[data-v-0df7c040] .snack__content .v-btn {
  margin: 0px;
  margin-left: 8px;
  padding: 7px;
}
.user-call-notification[data-v-0df7c040] {
  color: #000;
  margin-top: 35px;
  margin-right: 100px;
}
.user-call-notification[data-v-0df7c040] .snack__content {
  padding-bottom: 16px;
}
.user-call-notification[data-v-0df7c040] .snack__wrapper {
  max-width: 430px;
}
.img-responsive[data-v-0df7c040] {
  max-height: 80px;
  max-width: 80px;
  width: auto;
  height: auto;
  float: right;
}
.call-vibration[data-v-0df7c040] {
  animation-name: spaceboots;
  animation-duration: 0.8s;
  transform-origin: 50% 50%;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.auto-dpa[data-v-0df7c040] {
  background: lightgreen;
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 13px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
